module.exports = __webpack_public_path__ + "static/img/til12.47717c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til12.png
// module id = bfo0
// module chunks = 1